<app-dialog type="confirmation" [size]="DialogSize.SMALL" [dataSelector]="dataSelector + '-container'">
  <div class="d-flex flex-column align-items-center gap-6 pt-6" [dataSelector]="dataSelector + '-content'">
    <aiwyn-icon
      name="file-x"
      height="40"
      width="40"
      class="rounded-circle p-6 no-stroke-icon icon-fill-primary-base bg-color-gray-1100"
      [dataSelector]="dataSelector + '-icon'"
    ></aiwyn-icon>

    <h2 class="h2-500 color-gray-100 text-center" [dataSelector]="dataSelector + '-title'">This deliverable is no longer available</h2>

    <p class="body-300 color-gray-400 text-center" [dataSelector]="dataSelector + '-description'">
      The document you're trying to access has been removed by your accounting firm.
      This could be due to updates or changes in your documentation.
    </p>

    <p class="small-300 color-gray-400 text-center" [dataSelector]="dataSelector + '-help-text'">
      Need help? Contact Support at
      <a href="mailto:support@aiwyn.ai" class="color-primary-400" [dataSelector]="dataSelector + '-support-link'">support&#64;aiwyn.ai</a>
      or reach out to your account partners to the right.
    </p>
  </div>

  <app-dialog-footer [showCancel]="false" [dataSelector]="dataSelector + '-footer'">
    <button andButton size="large" color="primary" [mat-dialog-close]="true" [dataSelector]="dataSelector + '-close-button'">Close</button>
  </app-dialog-footer>
</app-dialog>
